import { Action } from "../actions/dashboardActions"
import { Dashboards } from "interfaces/dashboards"
import { DashboardActionType } from "state/action-types/dashboardTypes"

const initialState: Dashboards = {
    filters: {
        start_date: '',
        end_date: ''
    },
    operationalDashboard: {
        activeLives: 0,
        afterBirthFormsComparasion: {
            awaiting: 0,
            finished: 0
        },
        afterBirthRisk: {
            high: 0,
            low: 0,
            medium: 0
        },
        birthComparasion: {
            birth: 0,
            pregnant: 0
        },
        finishedForms: 0,
        formsComparasion: {
            awaiting: 0,
            finished: 0
        },
        inactiveLives: 0,
        initialFormsComparasion: {
            awaiting: 0,
            finished: 0
        },
        lateAfterBirthFormsComparasion: {
            awaiting: 0,
            finished: 0
        },
        lateAfterBirthRisk: {
            high: 0,
            low: 0,
            medium: 0
        },
        pregnantRisk: {
            high: 0,
            low: 0
        },
        secondQuarterFormsComparasion: {
            awaiting: 0,
            finished: 0
        },
        thirdQuarterFormsComparasion: {
            awaiting: 0,
            finished: 0
        }
    }
}

const reducer = (state: Dashboards = initialState, action: Action) => {
    switch (action.type) {
        case DashboardActionType.GET_OPERATIONAL_DASHBOARD:
            return {
                ...state,
                operationalDashboard: action.payload
            }
        case DashboardActionType.SET_DASHBOARD_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return state
    }
}

export default reducer